module.exports = __webpack_public_path__ + "b1abca4cb9d87cd7cd8e869d2013d2f3.svg";